import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Affiche un compteur décroissant pour afficher une promotion en
 * fonction de la date cible
 *
 * @param <Date> targetDate
 * @returns
 */
const Countdown = ({ targetDate }) => {
  const { t } = useTranslation();

  const calculateTimeLeft = () => {
    const difference = new Date(targetDate).getTime() - new Date().getTime();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        [t("time.days")]: Math.floor(difference / (1000 * 60 * 60 * 24)),
        [t("time.hours")]: Math.floor((difference / (1000 * 60 * 60)) % 24),
        [t("time.minutes")]: Math.floor((difference / 1000 / 60) % 60),
        [t("time.seconds")]: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  const formatDigits = (number) => {
    return String(number).padStart(2, "0").split("");
  };

  const timeLeftKeys = Object.keys(timeLeft);

  return (
    <div className="flex gap-2 items-center">
      {timeLeftKeys.map((interval, intervalIndex) => (
        <React.Fragment key={interval}>
          <div className="flex flex-col items-center text-center min-w-20">
            <div className="flex gap-[2px]">
              {formatDigits(timeLeft[interval]).map((digit, index) => (
                <div
                  key={index}
                  className="text-3xl text-oaRed font-extrabold w-[16px] h-[28px] flex items-center justify-center"
                >
                  {digit}
                </div>
              ))}
            </div>
            <div className="text-l  uppercase font-medium mt-1">{interval}</div>
          </div>
          {intervalIndex < timeLeftKeys.length - 1 && <div className="text-2xl text-oaRed font-extrabold mb-6">:</div>}
        </React.Fragment>
      ))}
      {Object.keys(timeLeft).length === 0 && (
        <span className="text-oaRed font-semibold animate-fade-in">{t("promo_ended")}</span>
      )}
    </div>
  );
};

export default Countdown;
